import { getSupabaseClient } from '@/integrations/supabase/client';
import type { Profile } from '@/types';

export const profileService = {
  async getProfile(userId: string): Promise<Profile | null> {
    const supabase = getSupabaseClient();
    const { data, error } = await supabase
      .from('profiles')
      .select('*')
      .eq('id', userId)
      .maybeSingle();

    if (error || !data) return null;

    return {
      id: data.id,
      username: data.username,
      full_name: data.full_name,
      created_at: data.created_at,
      updated_at: data.updated_at,
    };
  },
};
